import { Currency } from '../enums/retrieve-transaction.enums';

export const CurrenciesData = [
  { label: 'PHP', value: Currency.PHP.toString() },
  { label: 'USD', value: Currency.USD.toString() },
];
